<template>
	<CloResultsGallery
		dataFormat="search2.0"
		mediaVersion="2.0"
		:list="obsMediaData[speciesCode]"
		:mediaDownloadUrl="mediaDownloadUrl"
		:ebirdWebUrl="ebirdWebUrl"
		:mediaSpecimenUrl="mediaSpecimenUrl"
		externalLightbox
		:rowHeightForSmall="180"
		:rowHeightForMedium="view !== 'all' ? 360 : 180"
		:responsiveImages="false"
		caption="checklist"
		@open-lightbox="openLightbox"
	></CloResultsGallery>
</template>

<script>
import CloResultsGallery from '@/media/CloResultsGallery/CloResultsGallery.vue';

export default {
    name: 'ChecklistReportMedia',
    components: { CloResultsGallery },
    data() {
        return {
            obsMediaData: window.obsMediaData,
			view: 'all'
        };
    },
    props: {
        mediaDownloadUrl: {
            type: String,
            required: true,
        },
        ebirdWebUrl: {
            type: String,
            required: true,
        },
        mediaSpecimenUrl: {
            type: String,
            required: true,
        },
        speciesCode: {
            type: String,
            required: true,
        },
    },
	beforeMount() {
		const query = new URLSearchParams(window.location.search);
		const view = query.get('view');
		this.view = view ? view : 'all'
	},
    mounted() {
		document.addEventListener('checklist-report-view', (e) => {
			this.view = e.detail.view;
		});
	},
	methods: {
		// open lightbox
		openLightbox(assetId) {
			document.dispatchEvent(new CustomEvent('checklist-report-lightbox-open', { detail: assetId }));
		},
    },
}
</script>